import { isEmpty } from '@/utils/general/browserHelper'
import { Divider } from '@cleartrip/ct-design-components'
import React from 'react'
import { filterTypes } from '@/constants/Srp'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import FilterJourneyInfo from './FilterJourneyInfo'
import TimingFilter from './timingFilter'

const TimingsFilterNew = ({
  departureTimeFrom,
  returnDepartureTimeFrom,
  arrivalTimeFrom,
  returnArrivalTimeFrom,
  onFilterChange,
  isRT,
  processedData,
  resetTimingsFilters,
  selectedFilters,
  isRevamp = false,
}: any) => {
  const { source, destination } = processedData || {}
  const onClear = () => resetTimingsFilters(selectedFilters)
  const count = [departureTimeFrom, arrivalTimeFrom, returnDepartureTimeFrom, returnArrivalTimeFrom].reduce(
    (total: number, timing: any) => total + (timing?.[0]?.selectedValues?.length || 0),
    0
  )
  const showReturnLeg = isRT && (!isEmpty(returnDepartureTimeFrom?.[0]) || !isEmpty(returnArrivalTimeFrom?.[0]))

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Timings' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(departureTimeFrom?.[0]) && (
          <>
            <FilterJourneyInfo
              from={source}
              to={destination}
              isRT={isRT}
              isRevamp={isRevamp}
              legacyVariant='L2'
              legacyClassName='c-pointer py-3'
            />
            <TimingFilter
              departureTime={departureTimeFrom[0]}
              onFilterChange={onFilterChange}
              index={0}
              filterType={filterTypes.DEPARTURE_TIME_FROM}
              fromCode={processedData?.source}
              isRevamp={isRevamp}
            />
          </>
        )}

        {!isEmpty(arrivalTimeFrom?.[0]) && (
          <TimingFilter
            departureTime={arrivalTimeFrom[0]}
            onFilterChange={onFilterChange}
            index={0}
            filterType={filterTypes.ARRIVAL_TIME_FROM}
            toCode={processedData?.destination}
            isRevamp={isRevamp}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showReturnLeg} />

        {isRT && !isEmpty(returnDepartureTimeFrom?.[0]) && (
          <>
            {!isRevamp && <Divider className='w-100p my-2' borderColor='#E6E6E6' />}
            <FilterJourneyInfo
              from={destination}
              to={source}
              isRT={isRT}
              isRevamp={isRevamp}
              legacyVariant='L2'
              legacyClassName='c-pointer py-3'
            />
            <TimingFilter
              departureTime={returnDepartureTimeFrom[0]}
              onFilterChange={(type: any, value: any, index: number) => onFilterChange(type, value, index, 'returnLeg')}
              index={0}
              filterType={filterTypes.DEPARTURE_TIME_FROM}
              fromCode={processedData?.destination}
              isRevamp={isRevamp}
            />
          </>
        )}

        {isRT && !isEmpty(returnArrivalTimeFrom?.[0]) && (
          <TimingFilter
            departureTime={returnArrivalTimeFrom[0]}
            onFilterChange={(type: any, value: any, index: number) => onFilterChange(type, value, index, 'returnLeg')}
            index={0}
            filterType={filterTypes.ARRIVAL_TIME_FROM}
            toCode={processedData?.source}
            isRevamp={isRevamp}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default TimingsFilterNew
